import { edgeFunctionData } from '../../services/edgeFunctionData';
import { fetchEpicMonthBreakdown } from '../../services/jiraSync';

export default function jiraEpicMonthsHandlers(deps) {
  const { epicMonthCache, epicMonthOpen, setEpicMonthCache, setEpicMonthOpen } = deps;

  // Maintenance : dépliage d'un mois → temps passé par Epic ce mois-là (chargé à la demande)
  async function toggleEpicMonth(phaseId, projectKey, month) {
    const key = `${phaseId}|${month}`;
    const isOpen = !!epicMonthOpen[key];
    setEpicMonthOpen((o) => ({ ...o, [key]: !isOpen }));
    if (isOpen) return; // on referme : rien à charger
    const cached = epicMonthCache[key];
    if (cached && cached !== 'error') return; // déjà chargé (ou en cours)
    setEpicMonthCache((c) => ({ ...c, [key]: 'loading' }));
    try {
      const data = await edgeFunctionData(await fetchEpicMonthBreakdown(month, projectKey));
      setEpicMonthCache((c) => ({
        ...c,
        [key]: {
          byEpic: data.byEpic || {},
          byEpicTickets: data.byEpicTickets || {},
          total: data.total || 0,
        },
      }));
    } catch (e) {
      setEpicMonthCache((c) => ({ ...c, [key]: 'error' }));
    }
  }

  return { toggleEpicMonth };
}
